import {
  FormControl,
  FormLabel,
  HStack,
  Switch,
  Icon,
  Text,
  Flex,
  Popover,
  PopoverTrigger,
  useDisclosure,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
  IconButton,
} from "@chakra-ui/react";
import { BsFillQuestionCircleFill } from "react-icons/bs";
import { useCard } from "../../../../../hooks";

export function NotifyNewEntrySetting() {
  const { cardID, updateCard, card } = useCard();

  // Default to true when notifyOwnerOnNewEntry has never been explicitly set
  const notifyOwnerOnNewEntry = card?.notifyOwnerOnNewEntry !== false;

  function handleNotifyToggle(e: React.ChangeEvent<HTMLInputElement>) {
    if (cardID) {
      updateCard({ id: cardID, notifyOwnerOnNewEntry: e.target.checked });
    }
  }

  const id = "notify-new-entry";
  return (
    <FormControl display="flex" alignItems="center" justifyContent={"flex-end"}>
      <FormLabel htmlFor={id} mb="0">
        <HStack spacing="xs">
          <Text fontSize="sm">Notify me when someone adds an entry</Text>
          <InfoIconWithPopover />
        </HStack>
      </FormLabel>
      <Switch
        isChecked={notifyOwnerOnNewEntry}
        id={id}
        onChange={handleNotifyToggle}
      />
    </FormControl>
  );
}

function InfoIconWithPopover() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Flex>
      <Popover isOpen={isOpen} onClose={onClose} placement="top">
        <PopoverTrigger>
          <IconButton
            aria-label="notify-new-entry"
            variant="link"
            size="xs"
            icon={
              <Icon
                onClick={onOpen}
                as={BsFillQuestionCircleFill}
                fontSize="md"
                sx={{ color: "blue.500" }}
              />
            }
          />
        </PopoverTrigger>
        <PopoverContent>
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverBody>
            Sends the Cardoly creator an email when someone adds an entry
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Flex>
  );
}
